"use client";

import { ArrowRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent } from "@/components/ui/card";
export default function Expertise() {
  const {
    ref: framingRef,
    isVisible: framingVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: listRef,
    isVisible: listVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const disciplines = [{
    title: "Fabens Veterans Park Memorial",
    description: "Supported the El Paso County Water Control and Improvement District #4 with developing Fabens Veterans Park, including securing a $900,000 grant from the U.S. Economic Development Administration. The project includes the memorial, access, landscaping, and public-space improvements.",
    image: "https://infrapm.com/wp-content/uploads/2026/07/Veterans-Memorial-CGPT.png"
  }, {
    title: "Water Conservation\xA0SCADA Upgrades",
    description: "InfraPM supported El Paso County Water Control and Improvement District #4 with a $200,000 FY24 WaterSMART Water and Energy Efficiency Grant to upgrade municipal meters for advanced metering infrastructure integration, resulting in improved water use data, leak detection, and long-term water conservation in Fabens, Texas.",
    image: "https://infrapm.com/wp-content/uploads/2026/07/SCADA-Installation-CGPT.png"
  }, {
    title: "Elevated Water Storage Tank\xA0",
    description: "InfraPM supported project development for Van Horn’s Third Water Pressure Zone, advancing a water-capacity project that received $1.7 million from the U.S. Economic Development Administration to improve system pressure, expand elevated storage, add 6-inch supply lines and pump infrastructure, and reopen development capacity for commercial, residential, and public infrastructure growth.",
    image: "https://infrapm.com/wp-content/uploads/2026/07/VH-Third-Pressure-Zone-Aerial-scaled.jpg"
  }, {
    title: "Environmental Review for NMSU Arrowhead Center",
    description: "InfraPM supported federal environmental review documentation for New Mexico State University’s Arrowhead Center, helping advance a $1.1 million grant from the EDA for the Scale Up New Mexico programming focused on technology commercialization, startup support, intellectual property, venture readiness, and inclusive entrepreneurship across New Mexico.",
    image: "https://infrapm.com/wp-content/uploads/2026/07/Southern-NM-Building-Rendering-CGPT.png"
  }, {
    title: "Historic Mission Trail Development",
    description: "InfraPM staff supported project development for Mission Trail canal and trail improvements in Socorro and San Elizario, helping translate historic corridors into fundable infrastructure proposals for heritage tourism, active transportation, placemaking, and community connectivity.",
    image: "https://infrapm.com/wp-content/uploads/2026/07/San-Elizario-Mission-Sunrise-1.jpg"
  }, {
    title: "Regional Intelligence",
    description: "InfraPM provides regional intelligence support for utilities and water districts by tracking federal and Texas legislative, regulatory, funding, and compliance developments that may affect infrastructure planning, grant readiness, water reliability, procurement, and project delivery.",
    image: "https://infrapm.com/wp-content/uploads/2026/07/Congress-Drainage-IPM-scaled.jpg"
  }];
  return <section data-section-id="10701" id="core-services" className="bg-background py-24 md:py-32">
      <div className="mx-auto max-w-[1440px] px-6 md:px-12">
        <div className="flex flex-col gap-16">
          {}
          <div ref={framingRef} className="max-w-3xl" style={{
          opacity: framingVisible ? 1 : 0,
          transform: framingVisible ? "translateY(0)" : "translateY(16px)",
          transition: "opacity 520ms cubic-bezier(0.2, 0.0, 0.0, 1.0), transform 520ms cubic-bezier(0.2, 0.0, 0.0, 1.0)"
        }}>
            <h2 className="font-default text-[2.5rem] font-medium tracking-[-0.02em] leading-[1.1] !text-[rgba(24,51,78,1)] md:text-[3.25rem]" style={{
            color: "#18334e"
          }}>Client Portfolio</h2>

            

            
          </div>

          {}
          <div ref={listRef} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {disciplines.map((item, i) => <Card key={i} data-index={i} className="group border-border/50 rounded-lg shadow-md overflow-hidden transition-all duration-300 hover:shadow-lg" style={{
            opacity: listVisible ? 1 : 0,
            transform: listVisible ? "translateY(0)" : "translateY(24px)",
            transition: `opacity 600ms cubic-bezier(0.2, 0.0, 0.0, 1.0) ${i * 100}ms, transform 600ms cubic-bezier(0.2, 0.0, 0.0, 1.0) ${i * 100}ms`
          }}>
                <div className="aspect-[16/10] overflow-hidden">
                  <img src={item.image} data-wvc-srcset={`${item.image}-wvc-srcset`} data-wvc-sizes={`${item.image}-wvc-sizes`} alt={item.title} loading="lazy" className="w-full h-full object-cover grayscale-to-color-image" />
                </div>
                <CardContent className="p-8">
                  <h3 className="font-default text-xl font-semibold mb-4 tracking-tight group-hover:translate-x-1 transition-transform duration-300 !text-[rgba(24,51,78,1)]" style={{
                color: "#18334e"
              }}>
                    {item.title}
                  </h3>
                  <p className="font-default text-base leading-relaxed mb-6" style={{
                color: "#B0B0B0"
              }}>
                    {item.description}
                  </p>
                  
                </CardContent>
              </Card>)}
          </div>
        </div>
      </div>
    </section>;
}